import { images } from '../constants';

const services = [
    {
        id: 1,
        image: images.service1,
        title: 'Interior Design',
        content: 'Creative and innovative interior design solutions that transform spaces into stunning environments.',
        paragraphs: [
            'Elevate your spaces with our interior design services that blend functionality with aesthetic appeal. Whether it’s a residential home or a commercial area, our designers work closely with you to bring your vision to life.',
            'From concept development to final styling, we focus on creating personalized environments that reflect your taste, lifestyle, and purpose. We combine materials, colors, and textures to achieve harmony and elegance.'
        ],
        gallery: [
            images.service1Gallery1,
            images.service1Gallery2
        ],
        features: [
            'Customized Interior Concepts',
            'Space Planning & Layout Optimization',
            'Mood Boards & Material Selection',
            'Lighting & Color Coordination',
            'Furniture & Decor Curation'
        ],
        procedure: [
            'Initial Consultation & Briefing',
            'Conceptualization & Mood Board',
            'Design Development & Revisions',
            'Procurement & Installation',
            'Final Styling & Handover'
        ],
        faqs: [
            {
                id: 1,
                heading: 'What types of spaces do you design?',
                content: 'We design residential, commercial, and hospitality interiors—ranging from apartments and offices to cafes and showrooms.'
            },
            {
                id: 2,
                heading: 'Can I be involved in the design process?',
                content: 'Absolutely! We believe in a collaborative approach. Your input and feedback are welcomed at every stage of the project.'
            },
            {
                id: 3,
                heading: 'How long does an interior design project take?',
                content: 'Timelines vary by project scope, but a typical interior design project can take 4–8 weeks from initial consultation to final delivery.'
            },
            {
                id: 4,
                heading: 'Do you handle furniture and decor sourcing?',
                content: 'Yes, we manage sourcing, procurement, and styling to ensure every element aligns perfectly with your design vision.'
            }
        ]
    },
    {
        id: 2,
        image: images.service2,
        title: 'Architecture Planning',
        content: 'Strategic architecture planning services that bring your visions to life through careful design.',
        paragraphs: [
            'Our architectural planning services focus on creating innovative, functional, and sustainable building solutions. From initial concept to construction-ready designs, we ensure each project reflects your vision while adhering to regulatory and environmental standards.',
            'We blend creativity with technical expertise to deliver architectural plans that are efficient, structurally sound, and aesthetically aligned with modern or traditional styles. Our collaborative approach ensures a seamless design process tailored to your needs.'
        ],
        gallery: [
            images.service2Gallery1,
            images.service2Gallery2
        ],
        features: [
            'Conceptual Design & Planning',
            'Site Analysis & Feasibility',
            'Space Utilization Optimization',
            'Regulatory Compliance & Zoning',
            'Sustainable Design Integration'
        ],
        procedure: [
            'Client Briefing & Site Visit',
            'Conceptual Sketching & Analysis',
            'Preliminary Plan Presentation',
            'Detailed Architectural Drawings',
            'Final Approval & Documentation'
        ],
        faqs: [
            {
                id: 1,
                heading: 'What types of architecture projects do you plan?',
                content: 'We handle residential, commercial, institutional, and mixed-use developments, tailoring each plan to the project’s scope and goals.'
            },
            {
                id: 2,
                heading: 'Do you provide 3D models or visualizations?',
                content: 'Yes, we offer 3D renderings and walkthroughs to help you visualize your project before construction begins.'
            },
            {
                id: 3,
                heading: 'How do you ensure compliance with local building codes?',
                content: 'Our team is well-versed in local regulations and building codes. All plans are thoroughly reviewed to meet legal and safety standards.'
            },
            {
                id: 4,
                heading: 'Can you collaborate with our construction team or engineers?',
                content: 'Absolutely. We coordinate with contractors, engineers, and consultants to ensure smooth execution from planning to completion.'
            }
        ]
    },
    {
        id: 3,
        image: images.service3,
        title: 'Renovation Services',
        content: 'Expert renovation services to rejuvenate your living into more functional and appealing areas.',
        paragraphs: [
            'Our renovation services are designed to breathe new life into outdated or underutilized spaces. Whether it’s a single room or a full home makeover, we specialize in transforming interiors to reflect your lifestyle and taste.',
            'From structural adjustments to aesthetic upgrades, we manage every aspect of the renovation process with precision and care. Our team ensures that your space becomes more functional, stylish, and aligned with modern living standards.'
        ],
        gallery: [
            images.service3Gallery1,
            images.service3Gallery2
        ],
        features: [
            'Full & Partial Renovations',
            'Kitchen & Bathroom Makeovers',
            'Structural Enhancements',
            'Modern Material Integration',
            'End-to-End Project Management'
        ],
        procedure: [
            'Initial Consultation & Inspection',
            'Design Planning & Budgeting',
            'Material Selection & Procurement',
            'On-Site Renovation Work',
            'Final Walkthrough & Handover'
        ],
        faqs: [
            {
                id: 1,
                heading: 'What types of renovations do you handle?',
                content: 'We specialize in residential and commercial renovations, including kitchens, bathrooms, living areas, and structural upgrades.'
            },
            {
                id: 2,
                heading: 'Do you help with permits and approvals?',
                content: 'Yes, we assist with acquiring necessary permits and ensure all work complies with local building codes.'
            },
            {
                id: 3,
                heading: 'How long does a typical renovation take?',
                content: 'Timelines vary based on project scope, but most renovations are completed within 3–8 weeks from approval.'
            },
            {
                id: 4,
                heading: 'Can I live in my home during the renovation?',
                content: 'In many cases, yes. We plan around your schedule and work in phases to minimize disruption.'
            }
        ]
    },
    {
        id: 4,
        image: images.service4,
        title: 'Landscape Design',
        content: 'Beautiful landscape design services to enhance outdoor spaces, creating natural harmony.',
        paragraphs: [
            "Our landscape design services focus on transforming outdoor areas into serene, functional, and visually stunning environments. Whether it's a garden, patio, or entire yard, we design spaces that seamlessly blend nature with architectural elements.",
            'With a balance of greenery, hardscape features, and eco-conscious planning, we ensure every landscape project reflects beauty, usability, and sustainability for years to come.',
        ],
        gallery: [
            images.service4Gallery1,
            images.service4Gallery2
        ],
        features: [
            'Custom Garden Layouts',
            'Sustainable Planting Solutions',
            'Hardscape & Pathway Design',
            'Water Features & Lighting',
            'Seasonal Landscape Planning'
        ],
        procedure: [
            'Site Analysis & Consultation',
            'Concept Design & Revisions',
            'Material & Plant Selection',
            'Implementation & Construction',
            'Final Review & Maintenance Plan'
        ],
        faqs: [
            {
                id: 1,
                heading: 'What outdoor areas do you design?',
                content: 'We design a variety of outdoor spaces including residential gardens, courtyards, patios, and commercial landscapes.'
            },
            {
                id: 2,
                heading: 'Do you include sustainable practices?',
                content: 'Yes, we focus on sustainable landscaping using native plants, water-efficient systems, and eco-friendly materials.'
            },
            {
                id: 3,
                heading: 'How long does a landscape project take?',
                content: 'Depending on the scale, projects usually take 2–6 weeks from design approval to final installation.'
            },
            {
                id: 4,
                heading: 'Can I customize the plant selection?',
                content: 'Absolutely. We tailor all plantings based on your preferences, climate, and maintenance requirements.'
            }
        ]
    },
    {
        id: 5,
        image: images.service5,
        title: 'Project Management',
        content: 'Efficient project management services to oversee every aspect of your architecture projects from start to finish.',
        paragraphs: [
            'Our project management service ensures that your architectural and design initiatives are executed smoothly, on time, and within budget. We handle coordination between teams, manage schedules, and ensure adherence to design specifications and quality standards.',
            'From initial planning to final inspection, we take responsibility for every phase of the project, giving you peace of mind and consistent communication throughout the process.'
        ],
        gallery: [
            images.service5Gallery1,
            images.service5Gallery2
        ],
        features: [
            'Comprehensive Project Oversight',
            'Budget & Timeline Management',
            'Quality Assurance Checks',
            'Team & Vendor Coordination',
            'Regular Progress Reporting'
        ],
        procedure: [
            'Client Consultation & Goal Setting',
            'Timeline & Budget Planning',
            'Team Allocation & Kick-off',
            'Execution & Continuous Monitoring',
            'Final Delivery & Handover'
        ],
        faqs: [
            {
                id: 1,
                heading: 'What does a project manager handle?',
                content: 'We oversee scheduling, budgeting, team coordination, material procurement, and on-site progress to ensure project success.'
            },
            {
                id: 2,
                heading: 'Do you work with external contractors?',
                content: 'Yes, we collaborate with both in-house and external professionals, ensuring seamless integration and quality output.'
            },
            {
                id: 3,
                heading: 'How often will I receive updates?',
                content: 'We provide regular updates through meetings, emails, and reports, tailored to your preferred communication style.'
            },
            {
                id: 4,
                heading: 'Can you handle residential and commercial projects?',
                content: 'Absolutely. We manage projects of all scales and types, from home renovations to large-scale commercial developments.'
            }
        ]
    },
    {
        id: 6,
        image: images.service6,
        title: 'Consultation Services',
        content: 'Professional consultation services to guide and advise you on architectural and interior design decisions.',
        paragraphs: [
            'Our consultation services are tailored to provide expert guidance on architecture and interior design projects. Whether you’re just starting or refining an existing plan, we help you make informed decisions every step of the way.',
            'From space planning and material selection to lighting layouts and aesthetic direction, we work closely with you to align your vision with practical, innovative solutions.'
        ],
        gallery: [
            images.service6Gallery1,
            images.service6Gallery2
        ],
        features: [
            'Personalized Design Consultations',
            'Expert Recommendations on Materials & Layouts',
            'Budget-Conscious Planning',
            'Functional & Aesthetic Guidance',
            'Pre-Construction Planning Support'
        ],
        procedure: [
            'Initial Consultation & Goal Discussion',
            'Site Review or Virtual Analysis',
            'Concept Ideation & Strategy',
            'Design Recommendations',
            'Follow-up & Ongoing Guidance'
        ],
        faqs: [
            {
                id: 1,
                heading: 'Who can benefit from design consultations?',
                content: 'Homeowners, business owners, and developers looking for expert guidance in design planning, material selection, and spatial optimization.'
            },
            {
                id: 2,
                heading: 'Can I get consultation without a full project commitment?',
                content: 'Yes, we offer standalone consultations to help guide you through decision-making, even if you don’t proceed with a full service.'
            },
            {
                id: 3,
                heading: 'Do you offer virtual consultations?',
                content: 'Absolutely. We provide both in-person and virtual consultations to accommodate your location and preferences.'
            },
            {
                id: 4,
                heading: 'What should I prepare before the consultation?',
                content: 'Bring any floor plans, inspiration images, or questions you have. The more prepared you are, the more value we can provide during the session.'
            }
        ]
    }

];

export default services;